import * as React from 'react';

function SvgCreditCard2Back(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M11 5.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1z' />
			<path d='M2 2a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2H2zm13 2v5H1V4a1 1 0 011-1h12a1 1 0 011 1zm-1 9H2a1 1 0 01-1-1v-1h14v1a1 1 0 01-1 1z' />
		</svg>
	);
}

export default SvgCreditCard2Back;
